import axiosInstanceNode from "@/api/axiosInstanceNode";

// get deliverability settings api
export const getDeliverabilitySettings = async () => {
  try {
    const response = await axiosInstanceNode.get("/deliverability");
    return response.data;
  } catch (error) {
    console.error("Error getting deliverability settings:", error);
    throw error;
  }
};


// update deliverability settings api
export const updateDeliverabilitySettings = async (data) => {
  try {
    const response = await axiosInstanceNode.put("/deliverability", data);
    return response.data;
  } catch (error) {
    console.error("Error updating deliverability settings:", error);
    throw error;
  }
};

export const getDomainAuthentication = async () => {
  const response = await axiosInstanceNode.get("/deliverability/domain-authentication");
  return response.data;
};

export const verifyDomainAuthentication = async (dkimSelectors) => {
  const response = await axiosInstanceNode.post(
    "/deliverability/domain-authentication/verify",
    { dkimSelectors },
  );
  return response.data;
};
